import fetch from './fetch'

export default {
    getLaborScreeningsByPerson (payload) {
        let request = fetch({
            url: '/laborscreening',
            method: 'get',
            payload
        })
        return request.call()
    },

    createLaborScreening (payload) {
        let request = fetch({
            url: '/laborscreening',
            method: 'post',
            data: payload
        })

        return request.call()
    }
}



// WEBPACK FOOTER //
// ./src/api/laborScreening.js